import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Proposal/";

const GetProposalById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalById?proposalId=' + id, constants.REQUIRE_INTERCEPTORS);

const GetProposalManageInfo = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalManageInfo?proposalId=' + id, constants.REQUIRE_INTERCEPTORS);

const GetProposals = async (status) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposals?status=' + status, constants.REQUIRE_INTERCEPTORS);

const SaveProposal = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProposal', model, constants.REQUIRE_INTERCEPTORS);

const DeleteProposal = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProposal?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const SaveContactLog = async (proposalId, log) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveContactLog?proposalId=' + proposalId + '&log=' + log, {}, constants.REQUIRE_INTERCEPTORS);

const GetProposalReviewers = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalReviewers?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS)

const GetProposalPreview = async (proposalId, token) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalPreview?proposalId=' + proposalId + '&token=' + token, constants.REQUIRE_INTERCEPTORS);

const SaveProposalReviewers = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProposalReviewers', model, constants.REQUIRE_INTERCEPTORS);

const ClientProposalApproval = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'ClientProposalApproval', model, constants.REQUIRE_INTERCEPTORS);

const GetUserPermissionForProposal = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserPermissionForProposal?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS)

const GetProposalMessages = async (proposalId, length) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalMessages?proposalId=' + proposalId + '&length=' + length, constants.REQUIRE_INTERCEPTORS)

const GetReviewersHistory = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReviewersHistory?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const SetProposalAsReviewed = async (proposalId, userId) => await axiosInstance.post(ENDPOINTORIGIN + 'SetProposalAsReviewed?proposalId=' + proposalId + '&userId=' + userId, {}, constants.REQUIRE_INTERCEPTORS);

const AddExtension = async (proposalId, noOfHours) => await axiosInstance.post(ENDPOINTORIGIN + 'AddExtension?proposalId=' + proposalId + '&noOfHours=' + noOfHours, {}, constants.REQUIRE_INTERCEPTORS);

const GetProposalSendInfo = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalSendInfo?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const SendProposalToClient = async (proposalId) => await axiosInstance.post(ENDPOINTORIGIN + 'SendProposalToClient?proposalId=' + proposalId, {}, constants.REQUIRE_INTERCEPTORS);

const GetProposalEstimator = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalEstimator?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const SaveProposalEstimator = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProposalEstimator', model, constants.REQUIRE_INTERCEPTORS);

const RejectProposal = async (model) =>  await axiosInstance.post(ENDPOINTORIGIN + 'RejectProposal?proposalId=' + model.proposalId + '&rejectionReason=' + model.rejectionReason, {}, constants.REQUIRE_INTERCEPTORS);

const GetProposalProjectLogs = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalProjectLogs', constants.REQUIRE_INTERCEPTORS)

const ApproveProposal = async (proposalId) =>  await axiosInstance.post(ENDPOINTORIGIN + 'ApproveProposal?proposalId=' + proposalId, {}, constants.REQUIRE_INTERCEPTORS);

const GetRejectionReason = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetRejectionReason?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS)

const RemoveProposalEstimatorFile = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'RemoveProposalEstimatorFile?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS)

const GetEstimatedProjectNumber = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetEstimatedProjectNumber', constants.REQUIRE_INTERCEPTORS)

const ReviseProposal = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'ReviseProposal?proposalId=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    GetProposalById,
    GetProposals,
    SaveProposal,
    DeleteProposal,
    GetProposalManageInfo,
    SaveContactLog,
    GetProposalReviewers,
    SaveProposalReviewers,
    GetUserPermissionForProposal,
    GetProposalMessages,
    GetReviewersHistory,
    SetProposalAsReviewed,
    AddExtension,
    ClientProposalApproval,
    GetProposalPreview,
    GetProposalSendInfo,
    SendProposalToClient,
    GetProposalEstimator,
    SaveProposalEstimator,
    RejectProposal,
    GetProposalProjectLogs,
    ApproveProposal,
    GetRejectionReason,
    RemoveProposalEstimatorFile,
    GetEstimatedProjectNumber,
    ReviseProposal
}